import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const FeatureMainBodyLayout = ({ children, withBack, onPrevClick, title, className }) => {
  const history = useHistory();

  const closeStakingFeatures = () => history.push('/dashboard/staking');

  return (
    <div className={`d-flex flex-column main-layout-body-container ${className} main-body-layout`}>
      {withBack && (
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div
            className="cursor-pointer text-hover"
            onClick={onPrevClick}
            onKeyDown={onPrevClick}
            role="presentation">
            <i className="icon icon-arrow_back-navigation text-f5 me-2" aria-label="Back" />
          </div>

          {/* mobile only */}
          <div
            className="d-block d-md-none"
            onClick={closeStakingFeatures}
            onKeyDown={closeStakingFeatures}
            role="button"
            tabIndex={-1}>
            <i
              className="close-btn cursor-pointer icon icon-close-other text-dark text-f4 ms-2"
              aria-label="Close"
            />
          </div>
        </div>
      )}
      <div className="d-flex flex-row justify-content-start align-items-center mt-3 mt-md-4">
        <p className="d-block d-md-none text-dark text-f4">{title}</p>
        <p className="d-none d-md-block text-dark text-f3">{title}</p>
      </div>
      {children}
    </div>
  );
};

export default FeatureMainBodyLayout;

FeatureMainBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  onPrevClick: PropTypes.func,
};

FeatureMainBodyLayout.defaultProps = {
  withBack: false,
  title: null,
  children: null,
  className: '',
  onPrevClick: null,
};
